import { useEffect, useContext, useCallback } from 'react';

import useMediaQuery from '@mui/material/useMediaQuery';

import type { Auth } from '@shared/types';

import useAxios from '@services/api';

import { authContext } from '@store/index';

export const useFetchUser = () => {
  const [authData, setAuthData] = useContext(authContext);
  const { response, error, issueRequest, loading, statusCode } =
    useAxios<Auth>();

  const fetchUser = useCallback((force = false) => {
    // Не делаем запрос на странице логина, если не указан force
    if (!force && window.location.pathname.includes('/login')) {
      console.log('Skipping fetchUser on login page');
      return;
    }
    // Проверяем флаг принудительного выхода
    if (localStorage.getItem('forceLogout') === 'true') {
      console.log('Skipping fetchUser due to forceLogout flag');
      return;
    }
    console.log('🔍 Fetching user data...', { force, pathname: window.location.pathname });
    void issueRequest({ 
      url: '/user', 
      method: 'get',
      headers: {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache'
      }
    });
  }, [issueRequest]);

  useEffect(() => {
    if (response) {
      setAuthData(response);
    }

    if (statusCode === 401) {
      setAuthData(undefined);
    }
  }, [response, statusCode]);

  return [response, fetchUser, loading] as const;
};

export const useIsMobile = () => {
  const matches = useMediaQuery('(max-width:600px)');

  return matches;
};
